export enum SecureWebGatewayDNSFilteringType {
  BASIC = "basic",
  CUSTOM = "custom",
}
